import React, { useEffect, useState } from "react";
import classNames from "classnames";
import Moment from "react-moment";
import Barcode from "react-barcode";

import { cut } from "utils/cut";

import "./printLabel.scss";

export const PrintLabel = ({
  provider,
  number,
  quantityLabels = 1,
  setShowPrintLabels }) => {

  useEffect(() => {
    setTimeout(() => {
      window.print();
      setTimeout(() => {
        setShowPrintLabels(false);
      }, 200);
    }, 200);
  }, []);

  return (
    <>
      {[...Array(parseInt(quantityLabels))].map((_, i) =>
        <div className={classNames("supplyPrintLabel", "pageBreakAfter")}>
          <table>
            <tbody>
              <tr>
                <td className="providerName">
                  {cut(provider.label, 35)}
                </td>
              </tr>
              <tr>
                <td>
                  <Barcode height={40} fontSize={20} value={`S${number}`} format="CODE128" />
                </td>
              </tr>
              <tr>
                <td className="place">
                  {i + 1} / {quantityLabels}
                </td>
              </tr>
              <tr>
                <td className="date">
                  <Moment format="DD.MM.YYYY" interval={1000} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};